import { checkDrilldownFilterEmpty, getEmptyDrilldownFilterState } from 'src/app/components/filters/drilldown/drilldown-filter.component'
import { FilterId, IFilter } from '../interfaces/filter.interface'
import { checkRangeFilterEmpty, getEmptyRangeFilterState } from 'src/app/components/filters/range/range-filter.component'
import { checkZipCodeFilterEmpty, getEmptyZipCodeFilterState } from 'src/app/components/filters/zip-code/zip-code-filter.component'
import { checkListFilterEmpty, getEmptyListFilterState } from 'src/app/components/filters/list/list-filter.component'


export function getDefaultFilters(): IFilter[] {
  return [{
    id: FilterId.MakeModel,
    state: getEmptyDrilldownFilterState(),
    isEmpty: checkDrilldownFilterEmpty,
  }, {
    id: FilterId.CatSubcat,
    state: getEmptyDrilldownFilterState(),
    isEmpty: checkDrilldownFilterEmpty,
  }, {
    id: FilterId.Year,
    state: getEmptyDrilldownFilterState(),
    isEmpty: checkDrilldownFilterEmpty,
  }, {
    id: FilterId.Location,
    state: getEmptyDrilldownFilterState(),
    isEmpty: checkDrilldownFilterEmpty,
  }, {
    id: FilterId.PriceRange,
    state: getEmptyRangeFilterState(),
    isEmpty: checkRangeFilterEmpty,
  }, {
    id: FilterId.MilesRange,
    state: getEmptyRangeFilterState(),
    isEmpty: checkRangeFilterEmpty,
  }, {
    id: FilterId.HoursRange,
    state: getEmptyRangeFilterState(),
    isEmpty: checkRangeFilterEmpty,
  }, {
    id: FilterId.ZipCode,
    state: getEmptyZipCodeFilterState(),
    isEmpty: checkZipCodeFilterEmpty,
  }, {
    id: FilterId.QuickFilters,
    state: getEmptyListFilterState(),
    isEmpty: checkListFilterEmpty,
  }]
}
